<template>
  <div class="todo-list-wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title" @click="go('company-todo')">待办</span>
        <tabs
          :tab-list="todoTabs"
          :default-active="activeTodoType"
          @click="changeTodoTab"
          class="tabs"
        ></tabs>
      </div>
      <div class="time-range">
        <el-select
          v-if="activeTodoType === 'task'"
          v-model="timeRange"
          placeholder="请选择"
          @change="getTimeRange(timeRange)"
          class="time-range-select"
        >
          <el-option
            v-for="item in timeRangeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <ul
        ref="todoList"
        v-loading="dataLoading"
        v-show="todos && todos.length > 0"
        class="todo-list"
        v-ps
      >
        <li v-for="todo in todos" :key="todo.id" @click="clickTodo(todo)">
          <div class="todo-item">
            <div style="display: flex">
              <svg-icon icon-class="approval-pending"></svg-icon>
              <span class="todo-name" v-tip>{{ todo.name }}</span>
            </div>
            <div class="todo-info" v-if="activeTodoType === 'verify'">
              <svg-icon icon-class="verify-data"></svg-icon>
              <span
                v-if="todo.dataTitle !== '数据已删除'"
                v-tip
                style="color: #1989FA;"
                class="info"
              >
                <span @click.stop="openSheetDetail(todo)">{{ todo.dataTitle }}</span>
              </span>
              <span v-else class="info" style="color: #1989FA;" v-tip>{{ todo.dataTitle }}</span>
            </div>
            <div class="todo-info">
              <svg-icon icon-class="path"></svg-icon>
              <span class="info" v-tip>{{ todo.path }}</span>
            </div>
            <div class="todo-info" v-if="activeTodoType === 'verify'">
              <svg-icon icon-class="staff"></svg-icon>
              <span class="info">{{ todo.user.name }}</span>
            </div>
            <div class="todo-info" v-if="activeTodoType === 'task'">
              <svg-icon icon-class="deadline"></svg-icon>
              <span class="info" :style="{ color: todo.dueDateColor }">
                {{ todo.dueDateStr }}
              </span>
            </div>
            <div class="divider">
              <el-divider></el-divider>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="_.isEmpty(todos)" class="filter-empty">
        <svg-icon icon-class="noTodo"></svg-icon>
        <div class="no-available">
          暂无待办
        </div>
      </div>
    </el-card>
    <task-detail-dialog
      ref="detailDialog"
      :task-id="taskId"
      :visible.sync="taskDetailVisible"
      @data-changed="refresh"
    ></task-detail-dialog>
    <sheet-detail-dialog
      ref="detailDialog"
      :visible.sync="sheetDetailVisible"
      :data-id="sheetDataId"
      :app-id="sheetAppId"
      @data-changed="refresh"
    ></sheet-detail-dialog>
    <task-detail-dialog
      ref="taskDetailDialog"
      :task-id="taskTodoId"
      :visible.sync="detailDialogVisible"
      @data-changed="refresh"
      @trun-page="turnPage"
      :task-ids="tableDataIds"
    ></task-detail-dialog>
    <verify-sheet-data-dialog
      ref="verifySheetDataDialog"
      from="todo"
      :verify-ids="verifyIds"
      @turnVerify="turnVerify"
      @task-verified="refresh"
    ></verify-sheet-data-dialog>
  </div>
</template>

<script>
import Tabs from "@/components/UIComponents/Tab"
import { getTaskList } from "@/api/project/task"
import * as TaskApi from "@/api/task"
import TaskDetailDialog from "@/components/Task/DetailDialog"
import SheetDetailDialog from "@/components/Sheet/DetailDialog"
import { translateTaskList } from "@/utils/project"
import { quickTimeRange } from "@/components/Sheet/QuickSearch/static"
import VerifySheetDataDialog from "@/components/VerifySheetDataDialog"
import dj from "dayjs"

export default {
  name: "todo-list",
  components: { VerifySheetDataDialog, Tabs, TaskDetailDialog, SheetDetailDialog },
  props: { userInfo: Object },
  data() {
    return {
      activeTodoType: "verify",
      verifyTodoList: [],
      taskTodoList: [],
      timeRange: JSON.parse(localStorage.getItem("timeRange")) || "all",
      timeRangeArr: null,
      quickTimeRange,
      taskDetailVisible: false,
      sheetDetailVisible: false,
      detailDialogVisible: false,
      taskId: "",
      dataLoading: false,
      sheetDataId: "",
      sheetAppId: "",
      taskTodoId: "",
      verifyTotal: 0,
      taskTotal: 0,
      djFormat: "YYYY-MM-DD HH:mm:ss",
      pageInfo: {
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    todoTabs() {
      let result = []
      this.verifyTotal === 0
        ? result.push({ label: "待我审批", value: "verify" })
        : result.push({
            label: "待我审批(" + this.verifyTotal + ")",
            value: "verify"
          })
      this.taskTotal === 0
        ? result.push({ label: "待我完成", value: "task" })
        : result.push({ label: "待我完成(" + this.taskTotal + ")", value: "task" })
      return result
    },
    todos() {
      return this.activeTodoType === "verify" ? this.verifyTodoList : this.taskTodoList
    },
    timeRangeOptions() {
      return [{ label: "全部", value: "all" }].concat(this.quickTimeRange)
    },
    tableDataIds() {
      return this.transTaskIds(this.tableData)
    },
    verifyIds() {
      return this.verifyTodoList
        .filter(verifyRecord => verifyRecord.dataTitle !== "数据已删除")
        .map(verifyRecord => verifyRecord.id)
    }
  },
  created() {
    this.refresh()
  },
  mounted() {
    let todoList = this.$refs.todoList
    todoList.addEventListener("scroll", () => {
      let scrollTop = todoList.scrollTop
      let windowHeight = todoList.clientHeight || todoList.clientHeight
      let scrollHeight = todoList.scrollHeight || todoList.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        this.pageInfo.currentPage += 1
        if (this.activeTodoType === "verify") {
          this.getVerifyInfo()
        } else {
          this.getTaskInfo()
        }
      }
    })
  },
  methods: {
    refresh() {
      if (this.dataLoading) return
      this.dataLoading = true
      this.verifyTodoList = []
      this.taskTodoList = []
      this.pageInfo = { currentPage: 1, pageSize: 10 }
      this.getTimeRange(this.timeRange)
      Promise.all([this.getVerifyInfo(), this.getTaskInfo()]).finally(
        () => (this.dataLoading = false)
      )
    },
    getTimeRange(timeRange) {
      if (timeRange === "all") this.timeRangeArr = null
      else {
        let timeList = this.fastIntervalCompute(timeRange, new Date())
        this.timeRangeArr = [timeList.beginTime, timeList.endTime]
      }
      localStorage.setItem("timeRange", JSON.stringify(timeRange))
      this.getTaskInfo()
    },
    getVerifyInfo() {
      TaskApi.getTasks({
        state: "PENDING",
        page: this.pageInfo.currentPage - 1,
        size: this.pageInfo.pageSize
      }).then(res => {
        this.verifyTotal = res.totalElements
        res = res.content.map(todo => {
          if (todo.taskId) {
            todo.dataTitle = todo.taskName
            todo.path = todo.projectName
          } else {
            if (!todo.appName || !todo.sheetName) todo.path = ""
            else todo.path = todo.appName + " / " + todo.sheetName
          }
          if (todo.dataTitle === "数据已删除") {
            todo.deleted = true
          }
          return todo
        })
        if (this.pageInfo.page !== 1) {
          this.verifyTodoList = this.verifyTodoList.concat(res)
        } else {
          this.verifyTodoList = res
        }
      })
    },
    fastIntervalCompute(value, time) {
      let result = {}
      let unit = value.split("-")[1]
      let method = value.split("-")[0]
      switch (method) {
        case "last":
          time = dj(time).subtract(1, unit)
          break
        case "next":
          time = dj(time).add(1, unit)
          break
      }
      if (unit === "week") {
        result.beginTime = dj(time)
          .startOf(unit)
          .add(1, "day")
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .add(1, "day")
          .format(this.djFormat)
      } else {
        result.beginTime = dj(time)
          .startOf(unit)
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .format(this.djFormat)
      }
      return result
    },
    getTaskInfo() {
      getTaskList({
        listType: "MY_RUNNING",
        dueDate: this.timeRangeArr,
        page: this.pageInfo.currentPage - 1,
        size: this.pageInfo.pageSize
      }).then(res => {
        this.taskTotal = res.totalElements
        res = translateTaskList(res.content)
        if (this.pageInfo.currentPage !== 1) {
          this.taskTodoList = this.taskTodoList.concat(res)
        } else {
          this.taskTodoList = res
        }
      })
    },
    go(routerName) {
      this.$router.goto({ name: routerName })
    },
    changeTodoTab(key) {
      this.activeTodoType = key
      this.pageInfo = { currentPage: 1, pageSize: 10 }
    },
    clickTodo(todo) {
      switch (this.activeTodoType) {
        case "verify":
          // 审批的 数据/任务 已经不存在了，询问是否删除该审批
          if (todo.dataTitle === "数据已删除") {
            this.$confirm("审批数据不存在，是否删除该记录？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消"
            })
              .then(() => {
                TaskApi.deleteVerifyRecord(todo.id)
                  .then(() => this.$message.success("处理成功"))
                  .finally(this.refresh())
              })
              .catch(() => {
                //
              })
            return
          }
          this.$refs.verifySheetDataDialog.open(todo, todo.taskId ? "task" : "sheet")
          break
        case "task":
          this.openTaskTodoDetail(todo)
      }
    },
    openSheetDetail(row) {
      if (row.taskId) {
        this.taskId = row.taskId
        this.taskDetailVisible = true
      } else {
        this.sheetDataId = row.dataId
        this.sheetAppId = row.appId
        this.sheetDetailVisible = true
      }
    },
    openTaskTodoDetail(todo) {
      this.taskTodoId = todo.id
      this.detailDialogVisible = true
    },
    turnPage(dataId) {
      this.taskId = dataId
      this.$nextTick(() => this.$refs.taskDetailDialog.init())
    },
    transTaskIds(tasks) {
      if (!tasks) return []
      let res = []
      tasks.forEach(task => {
        res.push(task.id)
        res = res.concat(this.transTaskIds(task.children))
      })
      return res
    },
    turnVerify(todoId) {
      let todo = this.todos.find(todo => todo.id === todoId)
      this.$refs.verifySheetDataDialog.open(todo, todo.taskId ? "task" : "sheet", true)
    }
  }
}
</script>

<style lang="scss" scoped>
.todo-list-wrap {
  height: 100%;
  .el-card {
    border-radius: 6px;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-flow: column;
    ::v-deep {
      .el-card__body {
        flex: 1;
        overflow: hidden;
        padding: 10px 0 10px 10px;
      }
    }
  }
  .clearfix {
    border-bottom: 1px solid #ebeef5;
  }
  .title {
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
  }
  .tabs {
    margin-top: 10px;
  }
  .time-range {
    display: flex;
    justify-content: flex-end;
    .time-range-select {
      width: 100px;
      margin-right: 16px;
    }
  }
  .filter-empty {
    text-align: center;
    min-height: 200px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    .svg-icon,
    i {
      font-size: 160px;
      color: #fff;
    }
  }
  ::v-deep {
    .el-card__header {
      padding: 18px 20px 0 20px;
      border-bottom: none;
    }
    .el-icon-star-off:before {
      font-size: 15px;
    }
  }
  .todo-list {
    font-size: $font-size-main;
    height: 100%;
    padding-right: 10px;
    .divider {
      padding-top: 12px;
      .el-divider--horizontal {
        margin: 0;
        background-color: #f5f7fa;
      }
    }
    .todo-item {
      align-items: center;
      padding: 12px 11px 0;
      cursor: pointer;
      &:hover {
        background-color: $color-bg-select;
        border-radius: 6px;
      }
      &:only-child {
        border-bottom: none;
      }
    }
    .todo-name {
      font-size: 15px;
      margin: -3px 5px 2px 5px;
    }
    .todo-info {
      margin-left: 20px;
      margin-top: 1px;
      display: flex;
      .info {
        font-size: 12px;
        margin-left: 6px;
        color: #535c65;
      }
    }
  }
  .no-available {
    color: #c0c4cc;
    font-size: 14px;
  }
}
</style>
